'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _utils = require('utils');

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var planShape = _react2.default.PropTypes.shape({
  type: _react2.default.PropTypes.string.isRequired,
  name: _react2.default.PropTypes.string.isRequired,
  billing: _react2.default.PropTypes.string.isRequired,
  amount: _react2.default.PropTypes.number.isRequired,
  points: _react2.default.PropTypes.number.isRequired,
  accessResolutionName: _react2.default.PropTypes.string.isRequired
});

var PricingColumn = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PricingColumn, _React$Component);

  function PricingColumn(props) {
    (0, _classCallCheck3.default)(this, PricingColumn);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PricingColumn.__proto__ || (0, _getPrototypeOf2.default)(PricingColumn)).call(this, props));

    _this.onResolutionSwitchClicked = _this.onResolutionSwitchClicked.bind(_this);
    _this.onGreatRevenueCheckboxChanged = _this.onGreatRevenueCheckboxChanged.bind(_this);

    var plan = props.plan,
        plans = props.plans;

    var hasCollapsedPlans = !!plans;

    var selectedPlan = hasCollapsedPlans ? plans[0] : plan;

    var resolution = selectedPlan.accessResolution,
        greatRevenue = selectedPlan.higherRevenueAlternate;


    _this.state = {
      resolution: resolution,
      greatRevenue: greatRevenue
    };
    return _this;
  }

  (0, _createClass3.default)(PricingColumn, [{
    key: 'getCurrentPlan',
    value: function getCurrentPlan() {
      var _props = this.props,
          plan = _props.plan,
          plans = _props.plans;

      var hasCollapsedPlans = !!plans;

      var _state = this.state,
          resolution = _state.resolution,
          greatRevenue = _state.greatRevenue;


      return hasCollapsedPlans ? plans.find(function (p) {
        return p.accessResolution == resolution && (greatRevenue ? p.higherRevenueAlternate : true);
      }) : plan;
    }
  }, {
    key: 'onResolutionSwitchClicked',
    value: function onResolutionSwitchClicked(ev, resolution) {
      this.setState({ resolution: resolution });
    }
  }, {
    key: 'onGreatRevenueCheckboxChanged',
    value: function onGreatRevenueCheckboxChanged(ev) {
      this.setState({ greatRevenue: !!ev.currentTarget.checked });
    }
  }, {
    key: 'onContactUsClicked',
    value: function onContactUsClicked() {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactBox, {
        title: 'Subscription Upgrade',
        message: 'Looking to upgrade your subscription? Let us know what changes you would like to your plan and we will reply to you with all available options.',
        tag: 'regular-upgrade'
      }));
    }
  }, {
    key: 'renderResolutionSwitch',
    value: function renderResolutionSwitch() {
      var _classnames,
          _this2 = this;

      var styles = require('./PricingColumn.scss');

      var plans = this.props.plans;

      var resolutionOptions = _underscore2.default.uniq(plans.map(function (p) {
        return { name: p.accessResolutionName, value: p.accessResolution };
      }), function (o) {
        return o.value;
      });

      var currentPlan = this.getCurrentPlan();

      var classes = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.ResolutionSwitch, true), (0, _defineProperty3.default)(_classnames, styles['ResolutionSwitch--selectedOption2'], resolutionOptions[1].value == currentPlan.accessResolution), _classnames));

      return _react2.default.createElement(
        'div',
        { className: classes },
        resolutionOptions.map(function (o, i) {
          return _react2.default.createElement(
            'span',
            { className: styles.ResolutionSwitch__option, onClick: _underscore2.default.partial(_this2.onResolutionSwitchClicked, _underscore2.default, o.value) },
            o.name
          );
        })
      );
    }
  }, {
    key: 'renderGreatRevenueCheckbox',
    value: function renderGreatRevenueCheckbox() {
      var plans = this.props.plans;

      var show = _underscore2.default.uniq(plans, function (p) {
        return p.higherRevenueAlternate;
      }).length > 1;

      return show ? _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement('input', { type: 'checkbox', onChange: this.onGreatRevenueCheckboxChanged }),
        '\xA0',
        _react2.default.createElement(
          'span',
          null,
          'Revenue > $100K?'
        )
      ) : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2,
          _this3 = this;

      var styles = require('./PricingColumn.scss');

      var _props2 = this.props,
          plan = _props2.plan,
          plans = _props2.plans,
          subscription = _props2.subscription,
          userPlan = _props2.userPlan,
          onUpgradeClicked = _props2.onUpgradeClicked;

      var hasCollapsedPlans = !!plans;
      var showGreatRevenueCheckbox = _underscore2.default.uniq(plans, function (p) {
        return p.higherRevenueAlternate;
      }).length > 1;

      var _getCurrentPlan = this.getCurrentPlan(),
          type = _getCurrentPlan.type,
          name = _getCurrentPlan.name,
          billing = _getCurrentPlan.billing,
          amount = _getCurrentPlan.amount,
          points = _getCurrentPlan.points,
          license = _getCurrentPlan.license,
          accessResolutionName = _getCurrentPlan.accessResolutionName,
          upgradePoint = _getCurrentPlan.upgradePoint;

      var upgradable = userPlan && userPlan.upgradePoint < upgradePoint;

      var planClasses = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles.Plan, true), (0, _defineProperty3.default)(_classnames2, styles['Plan--green'], license == 'freelancer'), _classnames2));

      return _react2.default.createElement(
        'li',
        { className: planClasses, key: license },
        _react2.default.createElement(
          'div',
          { className: styles['Plan__title'] },
          name
        ),
        _react2.default.createElement(
          'div',
          { className: styles['Plan__details'] },
          hasCollapsedPlans && _react2.default.createElement(
            'div',
            { className: styles['Plan__details-block'] + ' ' + styles['Plan__details-block--resolutionSwitch'] },
            this.renderResolutionSwitch()
          ),
          _react2.default.createElement(
            'div',
            { className: styles['Plan__details-block'] },
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-value'] },
              _react2.default.createElement(
                'span',
                { className: styles['Plan__details-price'] },
                (0, _utils.prettyDollars)(amount)
              ),
              '\xA0',
              billing == 'monthly' && 'monthly',
              billing == 'annual' && 'annually'
            ),
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-label'] },
              license == 'hobby' && '1 x NON-COMMERCIAL LICENSE',
              license == 'freelancer' && '1 x FREELANCER LICENSE',
              license == 'indie' && 'MULTI-USER INDIE LICENSE'
            ),
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-info'] },
              _react2.default.createElement('img', { src: 'icons/info.svg', onClick: function onClick() {
                  _this3.context.dialogs.custom(_react2.default.createElement(_components.LicenseInfoDialog, { type: license }));
                } })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles['Plan__details-block'] },
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-value'] },
              points
            ),
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-label'] },
              'Points / ',
              billing == 'monthly' && 'Month',
              billing == 'annual' && 'Year'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles['Plan__details-block'] },
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-value'] },
              accessResolutionName
            ),
            _react2.default.createElement(
              'span',
              { className: styles['Plan__details-block-label'] },
              'Resolution'
            )
          )
        ),
        showGreatRevenueCheckbox && _react2.default.createElement(
          'div',
          { className: styles['Plan__details-block'] + ' ' + styles['Plan__details-block--greatRevenue'] },
          this.renderGreatRevenueCheckbox()
        ),
        subscription && subscription.isActive && !subscription.isTrial ? subscription.planId == type ? _react2.default.createElement(_components.Button, {
          disabled: true,
          label: 'My Subscription' }) : upgradable ? _react2.default.createElement(_components.Button, {
          primary: true,
          onClick: _underscore2.default.partial(onUpgradeClicked, type),
          label: 'Upgrade Now' }) : _react2.default.createElement(_components.Button, {
          onClick: this.onContactUsClicked.bind(this),
          label: 'Contact us' }) : _react2.default.createElement(_components.Button, {
          primary: true,
          link: true,
          to: '/subscribe/' + type,
          label: 'Sign up for ' + (0, _utils.prettyDollars)(amount) + ' / ' + (billing == 'monthly' ? 'mo' : billing == 'annual' ? 'yr' : '') })
      );
    }
  }]);
  return PricingColumn;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _class.propTypes = {
  plan: planShape,
  plans: _react2.default.PropTypes.arrayOf(planShape),
  onUpgradeClicked: _react2.default.PropTypes.func,
  subscription: _react2.default.PropTypes.object.isRequired
}, _temp);
exports.default = PricingColumn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PricingColumn/PricingColumn.jsx
// module id = 2759
// module chunks = 0